<div class="top-border">
    <div class="row   justify-content-start mb-2">
        <div class="col-9">
            <span class="iso-header">
                {{'bikeshop.shop_profile.whatsapp_integration.templates_header' | translate}}
            </span>
        </div>
        <div class="col-md-3">
            <div *ngIf="isWorkshop">
                <button pButton type="submit" class="p-button-raised full-width p-mini" [routerLink]="'/store/message-templates'" label="{{'bikeshop.shop_profile.whatsapp_integration.take_me_to_message_templates' | translate}}"></button>
            </div>
            <div *ngIf="isRentals">
                <button pButton type="submit" class="p-button-raised full-width p-mini" [routerLink]="'/store/rentals/message-templates'" label="{{'bikeshop.shop_profile.whatsapp_integration.take_me_to_message_templates' | translate}}"></button>
            </div>
        </div>
    </div>
    <div *ngIf="busy" style="display: block;">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4" fill="transparent"
            animationDuration=".5s">
        </p-progressSpinner>
    </div>

    <div *ngIf="!busy && (!messageTemplates || messageTemplates.length === 0)" class="no-templates-container">
        <div>{{ 'bikeshop.shop_profile.whatsapp_integration.no_whatsapp_templates' | translate }}</div>
    </div>

    <div class="template-container" *ngIf="!busy && messageTemplates && messageTemplates.length > 0">
        <div *ngFor="let messageTemplate of messageTemplates">
            <div class="template-header">{{ appConfig.getCustomLabelForMessageTag(messageTemplate.eventTag, (messageTemplate.eventTag + '_title'
                | translate : {
                    ServiceFollowUpReminderMonths:
                    partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService:
                    partner.ReminderHoursBeforeService, WaitingDelayHours: partner.WaitingDelayHours,
                    OtherServiceFollowUpReminderMonths: partner.OtherServiceFollowUpReminderMonths,
                    PostServiceFollowUpDays: partner.PostServiceFollowUpDays
                }), false) }}</div>
            <div class="category" *ngIf="messageTemplate.category">{{messageTemplate.category.toLowerCase()}}</div>
            <div class="status" *ngIf="messageTemplate.status" [ngClass]="{'approved': messageTemplate.status == 'APPROVED', 'not-approved': messageTemplate.status !== 'APPROVED'}">{{messageTemplate.status.toLowerCase()}}</div>
            <div class="reject-reason" *ngIf="messageTemplate.status !== 'APPROVED' && messageTemplate.rejectReason">{{messageTemplate.rejectReason && messageTemplate.rejectReason.error && messageTemplate.rejectReason.error.error_user_msg ? messageTemplate.rejectReason.error.error_user_msg : messageTemplate.rejectReason && messageTemplate.rejectReason.error && messageTemplate.rejectReason.error.message ? messageTemplate.rejectReason.error.message  : getObjectString(messageTemplate.WARejectReason)}}</div>
        </div>
    </div>
</div>